<template>
    <div>
        <apexchart
            class="apex-charts"
            height="320"
            type="pie"
            dir="ltr"
            :series="series"
            :options="pieChart.chartOptions"
        ></apexchart>
    </div>
</template>
<script>
    export default {
        props:[
            'title',
            'labels',
            'series'
        ],
        data(){
            return{
                pieChart:{
                    //series: [64, 55, 41, 17, 15,10],
                    chartOptions: {
                        labels: this.labels,
                        colors: ["#1E90FF","#FA8072","#90EE90","#FFD700","#87CEEB","#D2691E","#FFB6C1","#FF7F50","#90EE90","#9932CC"],
                        legend: {
                            show: true,
                            position: 'right',
                            horizontalAlign: 'center',
                            verticalAlign: 'middle',
                            floating: false,
                            fontSize: '14px',
                            offsetX: 0,
                            offsetY: 0
                        },
                        title: {
                            text: this.title,
                            align: 'bottom',
                            margin: 0,
                            offsetX: 0,
                            offsetY: 0,
                            floating: false,
                            style: {
                                fontSize:  '14px',
                                fontWeight:  'bold',
                                fontFamily:  undefined,
                                color:  '#000000'
                            },
                        },
                        responsive: [{
                            breakpoint: 600,
                            options: {
                                chart: {
                                    height: 300
                                },
                                legend: {
                                    show: true
                                },
                            }
                        }]
                    }
                },
            }
        },
    }
</script>

<style lang="scss" scoped>

</style>